module.exports = __webpack_public_path__ + "img/IMG_9914.879168da.jpg";